import React, { Component } from "react";
import PropTypes from "prop-types";
import functions from "../../api/functions.js";
import api from "../../api/api.js";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

export const CartContext = React.createContext();

class CartProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItems: [],
      loading: false,
      formaPagoID: 0,
      isCartOpen: false,
    };
  }

  static propTypes = {
    selectedItems: PropTypes.array,
    children: PropTypes.any
  };

  componentDidMount() {
    this.load();
  }

  decode() {
    let cart = localStorage.getItem("cartItems");
    if (cart) {
      let result = JSON.parse(atob(cart));
      return Array.isArray(result) ? result : [];
    } else {
      return false;
    }
  }

  removeAllItems(callback) {
    const { selectedItems } = this.state;
    // console.log("entre a removeAllItems");
    if (selectedItems.length > 0) {
      this.setState(
        prevState => {
          prevState.selectedItems = [];
          return prevState;
        },
        () => {
          this.save();
          if (callback) callback();
        }
      );
    }
  }

  load() {
    let decoded = this.decode();
    if (decoded) {
      this.setState({ selectedItems: decoded });
    }
  }
  setItems(items) {
    localStorage.removeItem("cartItems");
    localStorage.setItem("cartItems", btoa(JSON.stringify(items)));
    setTimeout(() => {
      this.setState(
        prevState => {
          prevState.selectedItems = items;
          return prevState;
        },
        () => {
          let cart = localStorage.getItem("cartItems");
          if (cart != undefined && cart != null && cart != "") {
            functions.post(api.api.setcartitem, 1, { cartItems: cart });
          }
        }
      );
    }, 100);
    return true;
  }

  encode() {
    const { selectedItems } = this.state;
    return btoa(JSON.stringify(selectedItems));
  }

  save() {
    localStorage.setItem("cartItems", this.encode());
    let cart = localStorage.getItem("cartItems");
    if (cart != undefined && cart != null && cart != "") {
      functions.post(api.api.setcartitem, 1, { cartItems: cart });
    }
  }


  setItem(code, quantity, deposit, callback) {
    if (quantity && !isNaN(quantity)) {
      this.setState(prevState => {
        const { selectedItems } = prevState;
        const newSelectedItems = [...selectedItems];

        const existingItemIndex = newSelectedItems.findIndex(item => item.code === code);
        if (existingItemIndex !== -1) {
          const existingItem = newSelectedItems[existingItemIndex];

          //console.log("Items existentes antes del SET:", existingItem); // Verifica cómo está antes de actualizar

          // Actualizar solo el depósito relevante
          if (deposit === 'buenos_aires') {
            existingItem.quantityBuenosAires = quantity;
          } else if (deposit === 'bahia_blanca') {
            existingItem.quantityBahiaBlanca = quantity;
          }else if (deposit === 'cordoba') {
            existingItem.quantityCordoba = quantity;
          }
          // Calcular la cantidad total del ítem
          existingItem.quantity = (existingItem.quantityBuenosAires || 0) + (existingItem.quantityBahiaBlanca || 0) + (existingItem.quantityCordoba || 0) ;
        } else {
          const newItem = {
            code: code,
            quantityBuenosAires: deposit === 'buenos_aires' ? quantity : 0,
            quantityBahiaBlanca: deposit === 'bahia_blanca' ? quantity : 0,
            quantityCordoba: deposit === 'cordoba' ? quantity : 0,
            quantity: quantity
          };
          newSelectedItems.push(newItem);
        }
        return { selectedItems: newSelectedItems };
      }, () => {

         //console.log("Items actualizados :", this.state.selectedItems); //verificamos el estado del carrito

        this.save();
        const totalQuantity = this.state.selectedItems.reduce((sum, item) => sum + item.quantity, 0);
        if (callback) callback({ quantity: totalQuantity });
      });
    } else {
      console.log('No se agregó el artículo debido a una cantidad inválida.');
    }
  }

  refreshUnderCriteria(criteria, callback) {
    const selectedItems = this.state.selectedItems.filter(item =>
      criteria(item)
    );
    let encoded = btoa(JSON.stringify(selectedItems));

    this.setState(
      initialPrevState => {
        initialPrevState.loading = true;
        return initialPrevState;
      },
      () => {
        functions.post(api.api.cart, null, { hash: encoded }, data => {
          if (callback) callback(data);
          this.setState(prevState => {
            prevState.loading = false;
            return prevState;
          });
        });
      }
    );
  }

  buyItem(code, quantity, callback) {
    let productsInCart = this.state.selectedItems;
    let issetInCart = productsInCart.find(product => product.code === code);

    const respNo = () => {
      return null;
    };

    const respSi = () => {
      if (quantity && !isNaN(quantity)) {
        const { selectedItems } = this.state;
        let items = selectedItems.filter(x => x.code === code);
        if (items.length) {
          this.setState(
            prevState => {
              prevState.selectedItems
                .filter(x => x.code === code)
                .forEach(x => {
                  x.quantity += quantity;
                  x.deposit = deposit;
                });
              return prevState;
            },
            () => {
              this.save();
              if (callback) callback();
            }
          );
        } else {
          this.setState(
            prevState => {
              prevState.selectedItems.push({ code: code, quantity: quantity, deposit: deposit  });
              return prevState;
            },
            () => {
              this.save();
              if (callback) callback();
            }
          );
        }
      } else {
        this.removeItem(code, callback);
      }
      window.location.replace("/#/cart/");
    };

    if (issetInCart != undefined) {
      confirmAlert({
        title: "Producto repetido",
        message:
          "El producto ya fue cargado en el carrito  ¿Quiere seguir agregando más unidades?",
        buttons: [
          {
            label: "Sí",
            onClick: () => respSi()
          },
          {
            label: "No",
            onClick: () => respNo()
          }
        ]
      });
    } else {
      respSi();
    }
  }

  removeItem(code, callback) {
    const { selectedItems } = this.state;
    let items = selectedItems.filter(x => x.code === code);
    if (items.length) {
      this.setState(
        prevState => {
          prevState.selectedItems = prevState.selectedItems.filter(
            x => x.code !== code
          );
          return prevState;
        },
        () => {
          this.save();
          if (callback) callback();
        }
      );
    }
  }

  removeItems(codes, callback) {
    const { selectedItems } = this.state;
    let items = selectedItems.filter(
      x => codes.filter(y => y === x.code).length
    );
    if (items.length) {
      this.setState(
        prevState => {
          prevState.selectedItems = prevState.selectedItems.filter(
            x => codes.filter(y => y === x.code).length === 0
          );
          return prevState;
        },
        () => {
          this.save();
          if (callback) callback();
        }
      );
    }
  }

  getQuantity(code = null) {
    const { selectedItems } = this.state;
    if (code) {
      const items = selectedItems.filter(x => x.code === code);
      if (items.length) {
        return items.map(x => x.quantity).reduce((a, b) => a + b);
      } else {
        return 1;
      }
    } else {
      const totalQuantity = selectedItems.reduce((total, item) => total + item.quantity, 0);
      return totalQuantity;
    }
  }


  getItems(callback) {
    this.setState(
      initialPrevState => {
        initialPrevState.loading = true;
        return initialPrevState;
      },
      () => {
        functions.post(api.api.cart, null, { hash: this.encode() }, data => {
          if (callback) callback(data);
         this.setState(prevState => {
            prevState.loading = false;
            return prevState;
          });
        });
      }
    );
  }

  isItemPresent(code = null) {
    const { selectedItems } = this.state;
    let items = selectedItems.filter(x => x.code === code);
    return items.length > 0;
  }


  setIsCartOpen = (isOpen) => {
    this.setState({ isCartOpen: isOpen });
}

  render() {
    const { selectedItems, loading, isCartOpen } = this.state;
    const { children } = this.props;
    return (
      <CartContext.Provider
        value={{
          selectedItems: selectedItems,
          quantity: code => this.getQuantity(code),
          setItem: (code, quantity, deposit, callback) =>
            this.setItem(code, quantity, deposit, callback),
          buyItem: (code, quantity, callback) =>
            this.buyItem(code, quantity, callback),
          removeItem: (code, callback) => this.removeItem(code, callback),
          removeItems: (codes, callback) => this.removeItems(codes, callback),
          removeAllItems: (callback) => this.removeAllItems(callback),
          items: callback => this.getItems(callback),
          clearCart: this.clearCart,
          loading: loading,
          refresh: (criteria, callback) =>
            this.refreshUnderCriteria(criteria, callback),
          isItemPresent: code => this.isItemPresent(code),
          setItems: items => this.setItems(items),
          clear: () => this.setItems([]),
          isCartOpen: this.state.isCartOpen,
          setIsCartOpen: this.setIsCartOpen,
        }}
      >
        {children}
      </CartContext.Provider>
    );
  }
}

export default CartProvider;



// WEBPACK FOOTER //
// ./src/components/ParadigmaCartProvider/ParadigmaCartProvider.js